import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { raiseToast } from '../toast/toast'
import { getSellerReqsByBuyerReqIds } from '../../../api/sellerReq'
import { getBuyerQuotesByBuyerReqIds } from '../../../api/buyerQuote'
import { getBuyerPOsByBuyerReqIds } from '../../../api/buyerPO'
import { getPOPunchByBuyerReqIds } from '../../../api/poPunch'
import { getSellerPOsByBuyerReqIds } from '../../../api/sellerPO'
import { getPIPunchByBuyerReqIds } from '../../../api/piPunch'
import { getBuyerInvoicesByBuyerReqIds } from '../../../api/buyerInvoice'
import { searchRequirementBuyerDashboard } from '../../../api/buyerReq'
import { getMaterialItemsDataByBuyerReqItemIds } from '../../../api/buyerReqItem'
import { getDispatchNotesByBuyerReqIds } from '../../../api/dispatchNote'

export const fetchBuyerDashboardRequirement = createAsyncThunk('user/getBuyerDasboardRequirement', async (params, { dispatch }) => {
    const response = await searchRequirementBuyerDashboard(params)
    if(response.failure){
        dispatch(raiseToast({severity:'error', summary: 'Requirement', detail: response.data.error, life: 3000}))
        throw Error()
    }
    return response
})

export const fetchMaterialsData = createAsyncThunk('user/getMaterials', async (data) => {
    const response = await getMaterialItemsDataByBuyerReqItemIds(data)
    console.log("Res materials", response)
    return response.data
})

// export const fetchSellerReq = createAsyncThunk('user/getSellerReq', async (data) => {
//     const response = await getSellerReqsByBuyerReqIds(data)
//     return response
// })

export const fetchBuyerQuotes = createAsyncThunk('user/getBuyerQuotes', async (data) => {
    const response = await getBuyerQuotesByBuyerReqIds(data)
    return response
})

export const fetchBuyerPOs = createAsyncThunk('buyer/getBuyerPOs', async (data) => {
    const response = await getBuyerPOsByBuyerReqIds(data)
    return response
})

// export const fetchPOPunch = createAsyncThunk('user/getPOPunch', async (data) => {
//     const response = await getPOPunchByBuyerReqIds(data)
//     return response
// })

// export const fetchSellerPO = createAsyncThunk('user/getSellerPO', async (data) => {
//     const response = await getSellerPOsByBuyerReqIds(data)
//     return response
// })

// export const fetchPIPunch = createAsyncThunk('user/getPIPunch', async (data) => {
//     const response = await getPIPunchByBuyerReqIds(data)
//     return response
// })

export const fetchBuyerInvoices = createAsyncThunk('user/getBuyerInvoice', async (data) => {
    const response = await getBuyerInvoicesByBuyerReqIds(data)
    return response
})

export const fetchDispatchNotes = createAsyncThunk('user/getDispatchNotes', async (data) => {
    const response = await getDispatchNotesByBuyerReqIds(data)
    return response
})

export const buyerDashboardRequirementSlice = createSlice({
    name : "user/getBuyerRequirementDashboard",
    initialState : {
        isInitialLoad: true,
        isLoading : false ,
        buyerRequirementData : [],
        materialProductsData: [],
        materialProductsLoading: false,
        // sellerReqData : [],
        // sellerReqLoading: false,
        buyerQuoteData : [],
        buyerQuoteLoading: false,
        buyerPOData : [],
        buyerPOLoading: false,
        // poPunchData : [],
        // poPunchLoading: false,
        // sellerPOData : [],
        // sellerPOLoading: false,
        // piPunchData : [],
        // piPunchLoading: false,
        buyerRequirementItemsData: [],
        materialProductsData: [],
        dispatchNoteData: [],
        dispatchNoteLoading: false,
        buyerInvoiceData: [],
        buyerInvoiceLoading: false,
        selectedBuyerQuoteId: null,
        selectedBuyerPOId: null,
        paginationParams : {
            pageNo: 0,
            totalRecords: 0,
            recordsPerPage: 10,
            limitedPagination: true,
            getCount: true
        },
        searchParams: {
            dataType: "requirementData",
            productType: "productType",
            searchBy: "all",
            searchText: "",
            dateType: "createdAt"
        },
        searchOptions: []
    },
    reducers: {
        setInitialLoad: (state, action) => {
            state.isInitialLoad = action.payload
        },
        updateSearchOptions: (state, action) => {
            state.searchOptions = action.payload
        },
        updateSearchParams: (state, action) => {
            state.searchParams = action.payload
        },
        setSelectedBuyerQuoteId: (state, action) => {
            state.selectedBuyerQuoteId = action.payload
        },
        setSelectedBuyerPOId: (state, action) => {
            state.selectedBuyerPOId = action.payload
        },
    },
    extraReducers : (builder) => {
        builder.addCase(
            fetchBuyerDashboardRequirement.fulfilled, (state, action) => {
                state.isLoading = false
                state.buyerRequirementData  = action.payload.data.data
                state.buyerRequirementItemsData = action.payload.data.buyerReqItems
                state.materialProductsData = action.payload.data.materialProducts
                state.paginationParams.pageNo = action.payload.data.pageNo-1
                state.paginationParams.recordsPerPage = action.payload.data.recordsPerPage
                if(action.payload.data.totalRecords || action.payload.data.totalRecords === 0){
                    state.paginationParams.totalRecords = action.payload.data.totalRecords
                }
                if(action.payload.data.excessPagesFound || !action.payload.data.excessPagesFound){
                    if(!state.paginationParams.excessPagesFound){
                        state.paginationParams.excessPagesFound = action.payload.data.excessPagesFound
                    }else if(action.payload.data.excessPagesFound === false){
                        state.paginationParams.excessPagesFound = false
                    }
                }
            }
        )
        .addCase(
            fetchBuyerDashboardRequirement.pending, (state, action) => {
                state.isLoading = true 
            }
        )
        .addCase(
            fetchBuyerDashboardRequirement.rejected, (state, action) => {
                state.isLoading = false
                state.buyerRequirementData  =  []
                state.paginationParams.totalRecords =  0
            }
        )
        .addCase(
            fetchMaterialsData.fulfilled, (state, action) => {
                state.materialProductsLoading = false 
                state.materialProductsData = action.payload
            }
        )
        .addCase(
            fetchMaterialsData.pending, (state, action) => {
                state.materialProductsLoading = true 
            }
        )
        .addCase(
            fetchMaterialsData.rejected, (state, action) => {
                state.materialProductsLoading = false
            }
        )
        // .addCase(
        //     fetchSellerReq.fulfilled, (state, action) => {
        //         state.sellerReqLoading = false 
        //         state.sellerReqData = action.payload
        //     }
        // )
        // .addCase(
        //     fetchSellerReq.pending, (state, action) => {
        //         state.sellerReqLoading = true 
        //     }
        // )
        // .addCase(
        //     fetchSellerReq.rejected, (state, action) => {
        //         state.sellerReqLoading = false
        //     }
        // )
        .addCase(
            fetchBuyerQuotes.fulfilled, (state, action) => {
                state.buyerQuoteLoading = false 
                state.buyerQuoteData  = action.payload
            }
        )
        .addCase(
            fetchBuyerQuotes.pending, (state, action) => {
                state.buyerQuoteLoading = true 
            }
        )
        .addCase(
            fetchBuyerQuotes.rejected, (state, action) => {
                state.buyerQuoteLoading = false
            }
        )
        .addCase(
            fetchBuyerPOs.fulfilled, (state, action) => {
                state.buyerPOLoading = false 
                state.buyerPOData  = action.payload.data
            }
        )
        .addCase(
            fetchBuyerPOs.pending, (state, action) => {
                state.buyerPOLoading = true 
            }
        )
        .addCase(
            fetchBuyerPOs.rejected, (state, action) => {
                state.buyerPOLoading = false
            }
        )
        // .addCase(
        //     fetchPOPunch.fulfilled, (state, action) => {
        //         state.poPunchLoading = false 
        //         state.poPunchData = action.payload
        //     }
        // )
        // .addCase(
        //     fetchPOPunch.pending, (state, action) => {
        //         state.poPunchLoading = true 
        //     }
        // )
        // .addCase(
        //     fetchPOPunch.rejected, (state, action) => {
        //         state.poPunchLoading = false
        //     }
        // )
        // .addCase(
        //     fetchSellerPO.fulfilled, (state, action) => {
        //         state.sellerPOLoading = false 
        //         state.sellerPOData = action.payload
        //     }
        // )
        // .addCase(
        //     fetchSellerPO.pending, (state, action) => {
        //         state.sellerPOLoading = true 
        //     }
        // )
        // .addCase(
        //     fetchSellerPO.rejected, (state, action) => {
        //         state.sellerPOLoading = false
        //     }
        // )
        // .addCase(
        //     fetchPIPunch.fulfilled, (state, action) => {
        //         state.piPunchLoading = false 
        //         state.piPunchData = action.payload
        //     }
        // )
        // .addCase(
        //     fetchPIPunch.pending, (state, action) => {
        //         state.piPunchLoading = true 
        //     }
        // )
        // .addCase(
        //     fetchPIPunch.rejected, (state, action) => {
        //         state.piPunchLoading = false
        //     }
        // )
        .addCase(
            fetchDispatchNotes.fulfilled, (state, action) => {
                state.dispatchNoteLoading = false 
                state.dispatchNoteData = action.payload
            }
        )
        .addCase(
            fetchDispatchNotes.pending, (state, action) => {
                state.dispatchNoteLoading = true 
            }
        )
        .addCase(
            fetchDispatchNotes.rejected, (state, action) => {
                state.dispatchNoteLoading = false
            }
        )
        .addCase(
            fetchBuyerInvoices.fulfilled, (state, action) => {
                state.buyerInvoiceLoading = false 
                state.buyerInvoiceData = action.payload
            }
        )
        .addCase(
            fetchBuyerInvoices.pending, (state, action) => {
                state.buyerInvoiceLoading = true 
            }
        )
        .addCase(
            fetchBuyerInvoices.rejected, (state, action) => {
                state.buyerInvoiceLoading = false
            }
        )
    }
})

export const { updateSearchParams, updateSearchOptions, setSelectedBuyerQuoteId, setSelectedBuyerPOId, setInitialLoad } = buyerDashboardRequirementSlice.actions

export default buyerDashboardRequirementSlice.reducer